export default __webpack_public_path__ + "static/payroll-portal-mockup-a83118959fae9b344cdc215a236f3c5d.png";